import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import AddPortForm from './AddPortForm';

const AddPortDialog = ({ open, onOpenChange, onAddPort }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (portData) => {
    setIsSubmitting(true);
    try {
      await onAddPort(portData);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
 <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Add New Port</DialogTitle>
        </DialogHeader>
        <AddPortForm 
          onAddPort={handleSubmit} 
          onCancel={() => onOpenChange(false)} 
          isSubmitting={isSubmitting}
        />
      </DialogContent>
    </Dialog>
  );
};

export default AddPortDialog;